import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    data: null,
    error: false,
};


const route = "devices/.components/maintenanceWarnings/.components/resolveMaintenanceWarningEvent/redux/slice";

export const resolveMaintenanceWarningEvents = createAsyncThunk("devices/.components/maintenanceWarnings/.components/confirmResolveMaintenanceWarningEvent/redux/slice/resolveMaintenanceWarningEvents", async (payload, { rejectWithValue, dispatch }) => {
    const { dateRange, unitId, warning } = payload
    try {
        let response = await clientMutation(`
            mutation resolveMaintenanceWarningEvents($unitId: Int!, $warning: String, $dateRange: AWSDateTimeRange!) {
                result: resolveMaintenanceWarningEvents(unitId: $unitId, warning: $warning, dateRange: $dateRange)
            }`,
            {
                unitId: unitId,
                warning: warning,
                dateRange: dateRange
            },
            endpoints.GRAPHQL_GENERAL
        )
        return { resolve: response?.result }

    } catch (exc) {
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'resolveMaintenanceWarningEvents');
        return rejectWithValue(exc);
    }
}
)


export const confirmResolveMaintenanceWarningEventsRedux = createSlice({
    name: 'devices/maintenanceWarnings/resolveMaintenanceWarningEvent',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalConfirmResolveMaintenanceWarningEvent(state, action) {
            state.openModal = true
            state.data = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resolveMaintenanceWarningEvents.pending, (state, action) => {
            state.loading = true
        });

        builder.addCase(resolveMaintenanceWarningEvents.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });

        builder.addCase(resolveMaintenanceWarningEvents.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
    }
})

const { actions, reducer } = confirmResolveMaintenanceWarningEventsRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalConfirmResolveMaintenanceWarningEvent
} = actions;

export default reducer;
